export const LEFT_TO_RIGHT_MARK = '\u200E';

// Helper function to check if a word contains Arabic or Hebrew characters (current RTL market languages)
export const isRTLWord = (word: string): boolean => {
    const RTL_REGEX = /[\u0590-\u05FF\u0600-\u06FF]/;
    return RTL_REGEX.test(word);
};

export const applyMark = (word: string, mark: string): string =>
    isRTLWord(word) ? word : `${mark}${word}${mark}`;

// Splits the text into parts while preserving spaces and applies LRM to LTR parts in RTL context.
export const processTextParts = (text: string, mark: string): string[] => {
    const parts = text.match(/(\S+|\s+)/g) || []; // Match non-whitespace characters and spaces

    const processedParts = parts.map(part => {
        if (part.trim() === '') return part;

        return applyMark(part, mark);
    });
    return processedParts;
};

/*
Handles directionality isolation.
When working with mixed content (LTR text and Western numbers) in RTL, the text flow can be disrupted when numbers are mixed with non-RTL text.
 */
/**
 * Applies LRM (Left-to-Right Mark) for LTR words/digits in RTL pages.
 * Returns the text unmodified for LTR pages or if no direction is specified.
 */
export const markLTRWordsForRTLDirectionality = (
    text: string,
    pageDirection: 'ltr' | 'rtl' = 'ltr'
): string => {
    // Only apply LRM for RTL pages
    if (pageDirection === 'ltr') return text;

    const processedParts = processTextParts(text, LEFT_TO_RIGHT_MARK);

    return processedParts.join('');
};
